module.exports = __webpack_public_path__ + "img/logo-kleyn-group.49ffa5be.svg";